import { render } from "./ProveedorPagoList.vue?vue&type=template&id=3a3e823a&scoped=true"
import script from "./ProveedorPagoList.vue?vue&type=script&lang=js"
export * from "./ProveedorPagoList.vue?vue&type=script&lang=js"

import "./ProveedorPagoList.vue?vue&type=style&index=0&id=3a3e823a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3e823a"]])

export default __exports__